import React, { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import './Hero.css';

const HERO_VIDEO_SRC = '/videos/home-hero-animation.mp4';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncMotionPreference = () => {
      if (mq.matches) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    };

    syncMotionPreference();
    mq.addEventListener('change', syncMotionPreference);
    return () => mq.removeEventListener('change', syncMotionPreference);
  }, []);

  const handleDemoClick = () => {
    ReactGA.event({
      category: 'user_engagement',
      action: 'early_access_click',
      label: 'hero_button',
    });
  };

  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero-inner">
        <div className="hero-content animate-fade-in">
          <h1 id="hero-heading" className="animate-slide-in-left">
            Security has a validation crisis.
            <span className="hero-title__answer">Circumvent fixes it.</span>
          </h1>
          <p className="animate-slide-in-left hero-lede">
            Circumvent investigates cloud and application findings against organization context and returns a
            verdict with evidence. Only verified work reaches the owner, in the tools they already use.
          </p>
          <div className="hero-buttons animate-slide-in-left">
            <a href="#contact" className="btn btn-gradient" onClick={handleDemoClick}>
              Request Demo
            </a>
            <a href="#features" className="btn btn-outline">
              Learn More
            </a>
          </div>
        </div>
      </div>

      <div className="hero-media" aria-hidden="true">
        <video
          ref={videoRef}
          className="hero-media__video"
          src={HERO_VIDEO_SRC}
          muted
          playsInline
          loop
          autoPlay
          preload="auto"
        />
      </div>
    </section>
  );
};

export default Hero;
